import * as types from './constants';

// Delete Assignment
export const deleteAssignmentRequest = data => (
  { type: types.DELETE_ASSIGNMENT_REQUEST, payload: data }
);

export const deleteAssignmentDone = data => (
  { type: types.DELETE_ASSIGNMENT_DONE, payload: data }
);

export const deleteAssignmentFailed = errors => (
  { type: types.DELETE_ASSIGNMENT_FAILED, payload: errors }
);